<div *ngIf="(isLoading | async) && showLoadingIndication" class="loading-skeleton">
    <div class="skeleton-shimmer"></div>
</div>

<div
    *ngIf="this.composedEditTakes$ | async as composedEditTakes"
    [class.hideme]="isHidden || ((isLoading | async) && showLoadingIndication)"
    class="all-wrapper">
    <ng-container *ngFor="let composedEditTake of composedEditTakes; index as editTakeIndex">
        <ng-container *ngFor="let layerAndOptions of composedEditTake.lottiesLayersAndOptions; index as lottieIndex">
            <div
                class="watermark"
                *ngIf="this.toDisplayWatermark && this.watermarkUrl"
                [style.background-image]="'url(' + this.baseCdnUrl + this.watermarkUrl + ')'"></div>
            <dynamic-lottie
                (animationCreated)="
                    animationCreated($event, layerAndOptions, composedEditTake.id, layerAndOptions.lottieLayer.lottieId)
                "
                (destroy)="animationDestroyed(composedEditTake.id + layerAndOptions.lottieLayer.lottieId)"
                [class.hideme]="layerAndOptions.isHidden$ | async"
                [config]="layerAndOptions.lottieData"
                [lottieOptions]="layerAndOptions.options"
                class="lottie-display"
                >>
            </dynamic-lottie>
            <!-- <ng-lottie
class="lottie-display"
(destroy)="
animationDestroyed(
composedScene.id + layerAndOptions.lottieLayer.lottieId
)
"
[class.hideme]="layerAndOptions.isHidden$ | async"
[options]="layerAndOptions.options"
(animationCreated)="
animationCreated(
$event,
layerAndOptions,
composedScene.id,
layerAndOptions.lottieLayer.lottieId
)
">
</ng-lottie> -->
        </ng-container>
        <ng-container *ngIf="composedEditTake.videoLayers as videoLayers">
            <app-scrub-bar
                (dragEndedEmitter)="dragEndedFromScrubBar()"
                (dragStartedEmitter)="dragStartedFromScrubBar()"
                (newSeekInMillisEmitter)="newTimeFromScrubBar($event)"
                [currentTimeInSeconds]="currentTimeInSeconds"
                *ngIf="videoLayers.length === 0"
                class="scrub-bar"></app-scrub-bar>
            <div *ngIf="videoLayers.length > 0" class="video-layer" style="width: 100%; height: 100%">
                <vg-player #vgPlayer [id]="composedEditTake.id">
                    <vg-controls
                        (drag)="$event.stopPropagation()"
                        (dragstart)="$event.stopPropagation()"
                        (mousedown)="$event.stopPropagation()"
                        *ngIf="this.displayVgControls"
                        [vgAutohideTime]="2.5"
                        [vgAutohide]="true">
                        <!-- (vgPlay)="onVgPlayPausea($event)" -->
                        <!-- <vg-scrub-bar #customScrubBar>
<vg-scrub-bar-current-time
[vgSlider]="true"
></vg-scrub-bar-current-time>
</vg-scrub-bar> -->
                        <app-scrub-bar
                            (dragEndedEmitter)="dragEndedFromScrubBar()"
                            (dragStartedEmitter)="dragStartedFromScrubBar()"
                            (newSeekInMillisEmitter)="newTimeFromScrubBar($event)"
                            [duration]="totalTrackDuration ? totalTrackDuration : totalDurationWithTrimsInMilliseconds"
                            [currentTime]="currentTime"
                            [navigateFromEditRoom]="this.navigateFromEditRoom"
                            [trimStart]="this.trimStart"
                            [trimEnd]="this.trimEnd"
                            [currentTimeInSeconds]="this.currentTimeWithTheTrimsInSeconds"
                            class="scrub-bar"></app-scrub-bar>
                        <div class="bottom-row row-centered">
                            <button
                                (click)="requestPlayOrPause(!playOrPause.isPlaying)"
                                [matTooltip]="playOrPause.isPlaying ? 'Pause' : 'Play'"
                                class="play-button"
                                mat-icon-button
                                tabindex="0">
                                <mat-icon>
                                    {{ playOrPause.isPlaying ? 'pause' : 'play_arrow' }}
                                </mat-icon>
                            </button>
                            <div class="row-centered" *ngIf="!navigateFromEditRoom; else editRoomTemplate">
                                <!--                                <vg-time-display vgFormat="mm:ss /" vgProperty="current"></vg-time-display>-->

                                <div class="time-display" *ngIf="isTimeVisible">
                                    {{
                                        (this.currentTimeToDisplayInMilliSeconds * 1000 >= 0
                                            ? currentTimeToDisplayInMilliSeconds * 1000
                                            : 0
                                        ) | timeFormat
                                    }}
                                    /
                                    {{ totalDurationWithTrimsInMilliseconds | timeFormat }}
                                </div>
                            </div>

                            <ng-template #editRoomTemplate>
                                <div class="row-centered">
                                    <div class="time-display">
                                        {{ currentTime | timeFormat }} / {{ totalTrackDuration | timeFormat }}
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </vg-controls>
                    <ng-container *ngFor="let videoLayer of videoLayers; let i = index">
                        <!-- custom-video.component.html -->

                        <ng-container *ngIf="!isIOS && !videoLayer.localUrlConfigs && videoLayer.dashPath; else noDash">
                            <video
                                vgMedia
                                #media
                                [class.hideme]="videoLayer.isHidden"
                                (loadedmetadata)="onLoadedMetadata($event, videoLayer, composedEditTake.id, 'DASH')"
                                (canplaythrough)="onCanPlayThrough($event, videoLayer, composedEditTake.id)"
                                [class.flip-horizontally]="videoLayer.toFlip"
                                [id]="composedEditTake.id + editTakeIndex"
                                [style.height]="videoLayer.videoPosition.height + '%'"
                                [style.left]="videoLayer.videoPosition.x + '%'"
                                [style.top]="videoLayer.videoPosition.y + '%'"
                                [style.width]="videoLayer.videoPosition.width + '%'"
                                [vgDash]="baseCdnUrl + videoLayer.dashPath"
                                [vgMedia]="$any(media)"
                                class="no-controls"
                                disablePictureInPicture
                                playsinline="true"
                                preload="auto"></video>
                            <!-- [src]="baseCdnUrl + videoLayer.uploadPath" -->

                            <!--                            <video-->
                            <!--                                id="subtitle-blank"-->
                            <!--                                class="subtitle-blank"-->
                            <!--                                [vgMedia]="subtitleBlank"-->
                            <!--                                #subtitleBlank-->
                            <!--                                disablePictureInPicture-->
                            <!--                                playsinline="true"-->
                            <!--                                muted-->
                            <!--                                [vgMaster]="false"-->
                            <!--                                preload="auto">-->
                            <!--                                <source-->
                            <!--                                    *ngIf="composeConfigs?.aspectRatio === aspectRatioEnum._9x16"-->
                            <!--                                    src="https://content.shuffll.com/files/platform/assets/empty-black-916.webm"-->
                            <!--                                    type="video/webm" />-->

                            <!--                                <source-->
                            <!--                                    *ngIf="composeConfigs?.aspectRatio === aspectRatioEnum._16x9"-->
                            <!--                                    src="https://content.shuffll.com/files/platform/assets/empty-black-169.webm"-->
                            <!--                                    type="video/webm" />-->

                            <!--                                <source-->
                            <!--                                    *ngIf="composeConfigs?.aspectRatio === aspectRatioEnum._1x1"-->
                            <!--                                    src="https://content.shuffll.com/files/platform/assets/empty-black-11.webm"-->
                            <!--                                    type="video/webm" />-->
                            <!--                            </video>-->
                        </ng-container>
                        <ng-template #noDash>
                            <video
                                vgMedia
                                #media
                                [appVideoSource]="{
                                    localUrl: videoLayer.localUrlConfigs,
                                    uploadUrl: baseCdnUrl + videoLayer.uploadPath,
                                }"
                                (loadedmetadata)="onLoadedMetadata($event, videoLayer, composedEditTake.id, 'NODASH')"
                                (canplaythrough)="onCanPlayThrough($event, videoLayer, composedEditTake.id)"
                                [class.flip-horizontally]="videoLayer.toFlip"
                                [class.hideme]="videoLayer.isHidden"
                                [id]="composedEditTake.id + editTakeIndex"
                                [style.height]="videoLayer.videoPosition.height + '%'"
                                [style.left]="videoLayer.videoPosition.x + '%'"
                                [style.top]="videoLayer.videoPosition.y + '%'"
                                [style.width]="videoLayer.videoPosition.width + '%'"
                                [vgMedia]="$any(media)"
                                class="no-controls"
                                disablePictureInPicture
                                playsinline="true"
                                preload="auto"></video>
                        </ng-template>
                    </ng-container>

                    <!-- crossorigin -->
                    <!-- <audio
                          #audioMedia
                          [vgMedia]="audioMedia"
                          id="audioMedia"
                          preload="auto"
                          [volume]="0.3"
                        >
                          <source
                            *ngFor="let audio of audioScenesOnTrack"
                            [src]="this.baseCdnUrl + audio.audioPath"
                             type="audio/mpeg"
                          />
                        </audio> -->
                </vg-player>
            </div>
        </ng-container>
    </ng-container>
</div>

<canvas
    #subtitlesCanvas
    class="subtitles-canvas"
    [class.aspect-916]="composeConfigs?.aspectRatio === aspectRatioEnum._9x16"
    [class.aspect-11]="composeConfigs?.aspectRatio === aspectRatioEnum._1x1"></canvas>

<div *ngIf="isBuffering" class="buffering-overlay">
    <mat-progress-spinner diameter="40" color="primary" mode="indeterminate"></mat-progress-spinner>
</div>

<div (click)="requestPlayOrPause(!this.playOrPause.isPlaying)" *ngIf="showPlayPauseOverlay" class="play-pause-overlay">
    <div class="icon-wrap">
        <mat-icon *ngIf="!this.playOrPause.isPlaying" class="play-icon" [@flipInXOnEnter] [@bounceOutOnLeave]
            >play_arrow
        </mat-icon>
    </div>
</div>

<video
    id="subtitle-blank"
    class="subtitle-blank"
    #subtitleBlank
    disablePictureInPicture
    playsinline="true"
    muted
    preload="auto">
    <source
        *ngIf="composeConfigs?.aspectRatio === aspectRatioEnum._9x16"
        src="https://content.shuffll.com/files/platform/assets/empty-black-916.webm"
        type="video/webm" />

    <source
        *ngIf="composeConfigs?.aspectRatio === aspectRatioEnum._16x9"
        src="https://content.shuffll.com/files/platform/assets/empty-black-169.webm"
        type="video/webm" />

    <source
        *ngIf="composeConfigs?.aspectRatio === aspectRatioEnum._1x1"
        src="https://content.shuffll.com/files/platform/assets/empty-black-11.webm"
        type="video/webm" />
</video>
